import { Predicate } from "@syncfusion/ej2-data";
import { openTaskExecutionDialog } from "../TaskExecutionDialog/openTaskExecutionDialog";
import { BoltTaskGridProps } from "./TaskGrid";
import { CommentPermissions } from "../TaskExecutionComponent/TaskExecutionActivityFeed";

const useTaskGrid = () => {
  const getPredicate = (
    entityTypeFilter?: string,
    entityIdFilter?: string,
    excludedTaskId?: string,
    onlyMyTasks?: boolean,
    currentUserId?: string
  ) => {
    if (!entityTypeFilter && !entityIdFilter && !onlyMyTasks) {
      return undefined;
    }

    let predicate: Predicate | undefined;

    if (entityTypeFilter) {
      predicate = new Predicate("parentEntityType", "equal", entityTypeFilter);
    }

    if (entityIdFilter) {
      const entityIdPredicate = new Predicate(
        "parentEntityId",
        "equal",
        `'${entityIdFilter}'`
      );
      if (predicate) {
        predicate = predicate.and(entityIdPredicate);
      } else {
        predicate = entityIdPredicate;
      }
    }

    if (excludedTaskId) {
      const excludedTaskIdPredicate = new Predicate(
        "id",
        "notequal",
        excludedTaskId
      );
      if (predicate) {
        predicate = predicate.and(excludedTaskIdPredicate);
      } else {
        predicate = excludedTaskIdPredicate;
      }
    }

    if (onlyMyTasks && currentUserId) {
      const assigneeIdPredicate = new Predicate(
        "assigneeId",
        "equal",
        currentUserId
      );
      if (predicate) {
        predicate = predicate.and(assigneeIdPredicate);
      } else {
        predicate = assigneeIdPredicate;
      }
    }

    return predicate;
  };

  const createOnRecordClick = (
    props: BoltTaskGridProps & {
      refreshGrid?: () => void;
      handleTaskComplete?: (taskId: string) => Promise<void>;
      taskExecutionLeftPanelIsDocked?: boolean;
      taskExecutionRightPanelIsDocked?: boolean;
      commentPermissions?: CommentPermissions;
    }
  ) => {
    return (ev: any) => {
      if (ev && ev.rowData.id) {
        openTaskExecutionDialog({
          taskId: ev.rowData.id,
          apiBaseUrl: props.apiBaseUrl,
          getAuthRequestHeader: props.getAuthRequestHeader,
          taskExecutionModuleRegistry: props.taskExecutionModuleRegistry,
          handleTaskComplete: props.handleTaskComplete || (async () => {}),
          onClose: () => {
            props.refreshGrid?.();
            props.onTasksChanged?.();
          },
          formRegistry: props.formRegistry,
          isTaskOverviewReadOnly: props.isTaskOverviewReadOnly,
          // simply pass props as `relatedTasksGridProps`
          relatedTasksGridProps: props,
          showRelatedTasks: props.showRelatedTasks,
          leftPanelIsDocked: props.taskExecutionLeftPanelIsDocked,
          rightPanelIsDocked: props.taskExecutionRightPanelIsDocked,
          commentPermissions: props.commentPermissions,
        });
      }
    };
  };

  return {
    getPredicate,
    createOnRecordClick,
  };
};

export default useTaskGrid;
